import { appSettings } from '@/shared/consts/appSettings'

export const getAnalyticsData = () => {
  const GA_COOKIE_NAME = appSettings.scheduleLeadWebhook.gaCookieName

  const cookies = document.cookie.split('; ')
  const gaCookie = cookies.find((cookie) => cookie.startsWith('_ga='))
  const clientId = gaCookie
    ? gaCookie.split('=')[1].split('.').slice(2).join('.')
    : ''

  const sessionCookie = cookies.find((cookie) =>
    cookie.startsWith(`${GA_COOKIE_NAME}=`)
  )

  let sessionId = ''
  let sessionNumber = ''

  if (sessionCookie) {
    const sessionParts = sessionCookie.split('=')[1].split('$')
    const prefixParts = sessionParts[0].split('.')

    sessionNumber = prefixParts[1]
    sessionId = sessionParts[3]?.slice(1)
  }

  return {
    sessionId,
    sessionNumber,
    clientId
  }
}
